import { render, staticRenderFns } from "./QueueChatsList.vue?vue&type=template&id=a6735e3a&scoped=true&"
import script from "./QueueChatsList.vue?vue&type=script&lang=js&"
export * from "./QueueChatsList.vue?vue&type=script&lang=js&"
import style0 from "./QueueChatsList.vue?vue&type=style&index=0&id=a6735e3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6735e3a",
  null
  
)

export default component.exports